module.exports = __webpack_public_path__ + "static/media/office-building.5af80cb3.webp";